export const USE_PAGINATION_DEFAULTS = {
  FIRST_PAGE: 1,
  ROWS_PER_PAGE: 10,
}
